// extracted by css-extract-rspack-plugin
export default {"textOverflow":"VDIShhj1OxM_469h","active":"UxLsf884ns8D5oaX"};